import Auth_API from "./apiConfig";

  export const getAllofflineEvents = async (params) => {
    try {
      const response = await Auth_API.get("user/events/offline/list", { params });
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }

    export const TransferTciket = async (payload) => {
    try {
      const response = await Auth_API.post("user/events/offline/ticket/transfer",payload);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }





  
  export const guestTicketApi = async (id) => {
    try {
      // const response = await Auth_API.get(`user/events/offline/ticket/details?qr_code=${id}`);
      const response = await Auth_API.get(`user/events/offline/ticket/details?qr_code=${id}`);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }

  // login: async (credentials) => {
	// 	try {
	// 		const response = await Auth_API.post("user/login", credentials)
	// 		if(response.data.response?.otp){
	// 			prompt('Your OTP is', response.data.response.otp)
	// 		}
	// 		return response.data
	// 	} catch (error) {
	// 		console.error(
	// 			"Login failed",
	// 			error?.response?.data || error.message
	// 		)
	// 		throw error // Re-throw for higher-level handling
	// 	}
	// },



  


   export const askRsvpApi = async (id) => {
    try {
      // const response = await Auth_API.get(`user/events/offline/ticket/details?qr_code=${id}`);
      const response = await Auth_API.get(`user/events/offline/status/askRsvp?eventId=${id}`);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }



    export const updateEventViewed = async (payload) => {
    try {
      const response = await Auth_API.post("/user/events/offline/ViewedEvent",payload);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }

      export const updateTicketViewed = async (payload) => {
    try {
      const response = await Auth_API.post("/user/events/offline/ViewTicket",payload);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }




     export const viewedRSVP = async (payload) => {
    try {
      const response = await Auth_API.post("/user/events/offline/ViewedRSVP",payload);
      return response.data;
    }
    catch (error) {
      if (error.response) {
        console.error("Server Error:", error.response.data.message || error.response.statusText);
        throw new Error(error.response.data.message || "Server Error");
      } else if (error.request) {
        console.error("Network Error:", error.message);
        throw new Error("Network Error. Please check your connection.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred. Please try again.");
      }
    }
  }